import React from "react";
import "./CustomPagination.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function CustomPagination() {
  return (
    <div className="CustomPagination">
      <div className="pagination-box">
        
        <button className="arrow-btn left">
          <FaChevronLeft />
        </button>

        <span className="page-count">1/3392</span>

        <button className="arrow-btn right">
          <FaChevronRight />
        </button>

      </div>
    </div>
  );
}

export default CustomPagination;